import { useLayoutEffect } from 'react';
import { useOptionalWorkspace } from '../context';
import type { EditingAppSelection } from '../../../src/apps/tracer/editing-base.mjs';

/** Host facts only, kept out of files and model tool arguments. The transport
 * snapshots them synchronously before it mirrors the submitted message. */
export function useEditingAppSelection(
  canvasKey: string,
  selected: EditingAppSelection | null | undefined,
  /** Unnamed because the preview itself is gone (refused, nothing on show), not because its App is unknown. */
  gone = false,
) {
  const ws = useOptionalWorkspace();
  const register = ws?.registerEditingApp;
  useLayoutEffect(
    () => register?.(canvasKey, selected, gone),
    [register, canvasKey, selected, gone],
  );
}
